import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { WelcomeScreenInputModel, WelcomeScreenTemplateModel } from '@platform/dashboard/models/welcome-screen-template-model.model';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'cp-mobile-welcome-modal',
  templateUrl: './mobile-welcome-modal.component.html',
  styleUrls: ['./mobile-welcome-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IconComponent, ButtonModule],
  animations: [
    trigger('slide', [
      state('up', style({ transform: 'translateY(-5rem)' })),
      state('down', style({ transform: 'translateY(0)' })),
      transition('* <=> *', animate('500ms')),
    ]),
  ],
})
export class MobileWelcomeModalComponent {
  @Input() welcomeModalData: WelcomeScreenInputModel;
  @Input() modalTemplateData: WelcomeScreenTemplateModel[];
  @Output() skipButtonClick = new EventEmitter();
  // Flag to show/hide the button
  showButton = false;

  onElementScroll(): void {
    this.showButton = true;
  }

  cancelTutorials(): void {
    this.skipButtonClick.emit();
  }
}
